module.exports = __webpack_public_path__ + "img/completed.c463c481.svg";